<template>
  <div class="course">
    <div v-show="!inviteFriends" class="join-course">
      <div class="join-success" v-if="paySuccess && signUpInfo.code !== 20000007">活动已报名</div>
      <div class="join-success" v-if="signUpInfo.code === 20000007">活动已结束</div>
      <img id="canvas-test-img" :src="signUpInfo.url || courseLoading" alt="poster" class="course-share" />
      <div class="course-title">{{ $_.get(signUpInfo, 'title') }}</div>
      <div id="anchor"></div>
      <a-form-model ref="form" :model="form" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
        <div style="width: 6.9rem;margin: .16rem auto">
          <!--根据后端传回 forms 生成表单-->
          <!-- TODO v-for 记得改回 signUpInfo.forms -->
          <a-form-model-item
            v-for="item of signUpInfo.forms"
            :key="item.name"
            :prop="item.key"
            :label="item.label"
            :rules="[{ required: item.required, message: item.message, trigger: 'blur' }]"
          >
            <!--单行输入框-->
            <a-input v-if="item.type === 'input'" v-model="form[item.key]" :placeholder="item.placeholder" />
            <!--省份下拉框-->
            <a-select v-if="item.type === 'province'" v-model="form[item.key]" :placeholder="item.placeholder" @select="getCity">
              <a-select-option v-for="item of provincesList" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
            </a-select>
            <!-- 城市下拉框 -->
            <a-select v-if="item.type === 'city'" v-model="form[item.key]" :placeholder="item.placeholder" notFoundContent="请先选择省份">
              <a-select-option v-for="item of cityList" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
            </a-select>
            <!--单选框-->
            <a-radio-group v-if="item.type === 'radio'" v-model="form[item.key]">
              <a-radio v-for="radio of item.group" :key="radio.value" :value="radio.value">{{ radio.label }}</a-radio>
              <a-radio value>
                其他
                <a-input
                  v-show="!item.group.map(item => item.value).includes(form[item.key])"
                  v-model="form[item.key]"
                  size="small"
                  :placeholder="item.placeholder"
                />
              </a-radio>
            </a-radio-group>
            <!--多行输入框-->
            <a-textarea
              v-if="item.type === 'textarea'"
              v-model="form[item.key]"
              :placeholder="item.placeholder"
              :autoSize="{ minRows: 6, maxRows: 6 }"
            />
          </a-form-model-item>
        </div>
        <div style="margin: 50px 0 0;" class="bottom-button">
          <div v-if="signUpInfo.code !== 20000007">
            <a-button
              v-if="!paySuccess"
              color="#ff5000"
              style="height: 1.12rem;width: 100vw;font-size: .4rem;border-radius: 0;"
              type="primary"
              @click="onSubmit"
            >{{ $_.get(courseInfo, 'checkInStatus.statusLiteral', '提交') }}</a-button>
            <!--已提交按钮-->
            <div v-else class="align jus all-share-box">
              <div
                class="to-share flex-all"
                @click="invite()"
                :style="
                  `color: ${bottomButtonRight().color ||
                    '#fff'};background-color: ${bottomButtonRight().bg || 'FF5000'}`
                "
              >{{ $_.get(courseInfo, 'checkInStatus.statusLiteral') }}</div>
            </div>
          </div>
          <div v-else class="registration-end">报名已关闭</div>
        </div>
      </a-form-model>
      <div v-if="joinSuccess || paySuccess" class="pay-success">
        <div class="pay-success-title align jus">
          <icon type="duihao2" size=".6rem"></icon>
          <div style="margin-left: .2rem">提交成功</div>
        </div>
        <div class="pay-success-tips" v-html="$_.get(courseInfo, 'checkInStatus.successDesc')"></div>
        <DrawShare v-if="showShareImage" />
        <EnterGroupWxCode v-if="$_.get(courseInfo, 'checkInStatus.status')" :img="$_.get(signUpInfo,'options.inviteQRCode')" />
      </div>
    </div>
    <InviteFriends v-if="inviteFriends" :inviteFriends.sync="inviteFriends" />
  </div>
</template>

<script>
import DrawShare from './DrawShare';
import InviteFriends from './InviteFriends';
import EnterGroupWxCode from './EnterGroupWxCode';
import { Toast } from 'vant';
import Pay from '../../helper/pay';
import device from './devices';
import arr from './form';

export default {
  components: { DrawShare, InviteFriends, EnterGroupWxCode },
  computed: {
    courseInfo() {
      // 报名的三个状态 NOT_CHECK_IN - 未报名 CHECK_IN_FREE - 已经免费报名 CHECK_IN_PAYED - 已经付费报名
      // 有三个免费名额的邀请 也相当于免费报名 因为他可以邀请 然后二维码的生成 由后段掌控
      return this.$store.state.courseInfo;
    }
  },
  data() {
    return {
      arr,
      eventId: this.$route.query.operationsEventsId || 1,
      form: {},
      // 用户的基本信息，在每次进来的时候会进行请求
      signUpInfo: {},
      // 支付状态
      paySuccess: false,
      // 参加状态
      joinSuccess: false,
      // 邀请海报
      inviteFriends: false,
      courseLoading: 'https://s6.bihukankan.com/h5static/img/0324course_loading1.png',
      showShareImage: false,
      provincesList: [],
      cityList: []
    };
  },
  mounted() {
    this.getSignUp();
    this.$removeWxShare();
    this.addKeywordFocus();
    this.getProvinces();
  },
  methods: {
    getProvinces() {
      this.$get({
        road: 'region',
        version: 'v2',
        params: { level: 1 }
      }).then(res => {
        this.provincesList = res;
      });
    },
    getCity(name) {
      this.$get({
        road: 'region',
        version: 'v2',
        params: { name, level: 2 }
      }).then(res => {
        this.$set(this.form, 'city', undefined);
        this.$refs.form.clearValidate('city');
        this.cityList = res;
      });
    },
    bottomButtonRight() {
      let statusLiteral = this.$_.get(this.courseInfo, 'checkInStatus.statusLiteral');
      if (statusLiteral === '报名成功') {
        return { bg: '#8c8c8c', color: '#262626' };
      } else {
        return {};
      }
    },
    getSignUp(again) {
      this.$get({
        road: 'operationsEventsCheckIn',
        data: { id: this.eventId },
        // userDistributionId 必传，不然404
        params: { userDistributionId: this.$route.query.userDistributionId || 990000 },
        version: 'v2'
      }).then(res => {
        if (!again) {
          document.title = res.title || this.$_.get(res, 'response.title') || '壁虎看看';
        }
        this.$store.commit('WRITECOURSEINFO', res);
        this.paySuccess = res.isCheckIn;
        // 这里为什么这样写呢，是因为在过期之后 会给我加一个response，多了一层，2333
        this.signUpInfo = { ...res, ...res.response };
        let { content = {} } = res.checkIn || {};
        if (content) {
          this.form = content;
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          Toast.loading({
            message: '',
            duration: 0,
            loadingType: 'spinner',
            className: 'toast-no-dialog'
          });
          this.$post({
            road: 'operationsEventsCheckIn',
            data: { id: this.eventId },
            params: {
              userDistributionId: this.$route.query.userDistributionId || 990000,
              content: { ...this.form }
            },
            version: 'v2'
          })
            .then(res => {
              this.$hideLoading();
              // 判断有订单需要支付就是显示有bussinessOrder
              if (res.businessOrder) {
                this.pay(res);
              } else {
                this.getSignUp(true);
                this.checkin = true
                this.paySuccess = true;
                this.joinSuccess = true;
                this.$store.commit('WRITECOURSEINFO', res);
                document.title = '报名成功';
              }
            })
            .catch(err => {
              this.$hideLoading();
              this.$toast(`提交失败，${this.$_.get(err, 'response.message')}`);
            });
        } else {
          document.getElementById('anchor').scrollIntoView();
        }
      });
    },
    pay(val) {
      Pay(val.businessOrder)
        .then(res => {
          this.getSignUp(true);
          this.paySuccess = true;
          this.joinSuccess = true;
          this.showShareImage = res.showShareImage;
          document.title = '报名成功';
        })
        .catch(err => {
        });
    },
    // 邀请朋友
    invite() {
      let statusLiteral = this.$_.get(this.courseInfo, 'checkInStatus.statusLiteral');
      if (statusLiteral !== '报名成功') {
        document.title = '长按保存图片';
        this.inviteFriends = true;
      }
    },
    // https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800
    addKeywordFocus() {
      let isReset = true; //是否归为
      if (device() === 'ios') {
        document.body.addEventListener('focusin', () => {
          //软键盘弹出的事件处理
          isReset = false;
        });
        document.body.addEventListener('focusout', () => {
          //软键盘收起的事件处理
          isReset = true;
          setTimeout(() => {
            //当焦点在弹出层的输入框之间切换时先不归位
            if (isReset) {
              //失焦后强制让页面归位
              // window.scroll(0, 0);
              // 试试优化下归位体验，看不滚到 top 会不会错位
              document.getElementById('anchor').scrollIntoView();
            }
          }, 300);
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.course {
  background: #f5f5f5;

  .join-success {
    background: #fdf3d1;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.32rem;
    color: #ff5000;
    padding-left: 0.8rem;
  }

  .join-course {
    padding-bottom: 1.4rem;
  }

  .course-share {
    width: 100vw;
  }

  .course-title {
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.4rem;
    border-bottom: 0.01rem solid #d9d9d9;
    padding: 0.32rem 0.64rem;
  }
}

.pay-success {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #f5f5f5;
  z-index: 10;

  .pay-success-title {
    font-size: 0.6rem;
    line-height: 0.8rem;
    text-align: center;
    color: #000000;
    padding-top: 0.7rem;
  }

  .qrcode {
    width: 4rem;
    display: block;
    margin: 0 auto;
  }

  .pay-success-tips {
    font-size: 0.4rem;
    line-height: 0.6rem;
    width: 5.8rem;
    margin: 0.1rem auto;

    .my-course {
      color: #4a90e2;
    }
  }
}

.bottom-button {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  z-index: 1;

  .all-share-box,
  .registration-end {
    height: 1.12rem;
    text-align: center;
    line-height: 1.12rem;
    font-size: 0.4rem;
    background: #fff;

    .to-share {
      background: #2a89f4;
      color: #fff;
    }
  }

  .registration-end {
    background: #8c8c8c;
    font-size: 0.4rem;
  }
}
</style>

<style lang="less">
.ant-radio-wrapper {
  display: block;
  height: 0.6rem;
  line-height: 0.6rem;
}

.bottom-button {
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
